import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Settings", -1)

import { computed, ref, watch } from 'vue'
import { usePolicyConfig } from '..'
import { ConfigProperty, createSettingsConfig } from './config'
import { MdmPolicySchema } from '@/generated/sdk'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  __name: 'PolicyConfigurationSettings',
  setup(__props) {

const store = useStore()

const { policyConfig } = usePolicyConfig()
const formData = ref<ConfigProperty[]>(createSettingsConfig())

const currentMdmPolicy = computed<MdmPolicySchema>(() => store.state.policies.currentPolicy)

const showSettingsForm = ref(false)
const showResult = ref(false)
const hasErrors = ref(false)

const tableConfig = createSettingsConfig()

watch(policyConfig, () => {
  formData.value.forEach(property => {
    if (policyConfig.value[property.id] == null) return

    property.value = policyConfig.value[property.id]
  })
})

function parseSettings(): void {
  // parse properties according to their type
  formData.value.forEach(property => {
    if (property.type === 'json') {
      property.value = JSON.parse(property.value)
    }
    if (property.type === 'multiselect') {
      if (Array.isArray(property.value) && property.value.length === 0) {
        property.value = null
      }
    }
    policyConfig.value[property.id] = property.value
  })
  showSettingsForm.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_DodoColumn = _resolveComponent("DodoColumn")!
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_PolicyConfigurationSettingsTable = _resolveComponent("PolicyConfigurationSettingsTable")!
  const _component_FormBuilder = _resolveComponent("FormBuilder")!
  const _component_PrimeDialog = _resolveComponent("PrimeDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DodoRow, { justify: "between" }, {
      default: _withCtx(() => [
        _createVNode(_component_DodoColumn, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_DodoColumn, null, {
          default: _withCtx(() => [
            _createVNode(_component_DodoRow, { justify: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_DodoButton, {
                  variant: "solid",
                  color: "info",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showResult.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DodoIcon, { name: "visibility" }),
                    _createTextVNode(" Show result ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_DodoButton, {
                  variant: "solid",
                  color: "info",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showSettingsForm.value = true))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DodoIcon, { name: "edit" }),
                    _createTextVNode(" Edit settings ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_PolicyConfigurationSettingsTable, {
      "policy-config": _unref(policyConfig),
      "settings-config": _unref(tableConfig),
      "edit-mode": true
    }, null, 8, ["policy-config", "settings-config"]),
    _createVNode(_component_PrimeDialog, {
      visible: showSettingsForm.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((showSettingsForm).value = $event)),
      modal: "",
      header: "Adjust settings",
      style: { width: '65vw' },
      breakpoints: { '960px': '75vw', '641px': '100vw' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormBuilder, {
          "config-properties": formData.value,
          "onUpdate:configProperties": _cache[2] || (_cache[2] = ($event: any) => ((formData).value = $event)),
          "has-errors": hasErrors.value,
          "onUpdate:hasErrors": _cache[3] || (_cache[3] = ($event: any) => ((hasErrors).value = $event))
        }, null, 8, ["config-properties", "has-errors"]),
        _createVNode(_component_DodoButton, {
          variant: "solid",
          color: "info",
          disabled: hasErrors.value,
          onClick: parseSettings
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Apply changes ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PrimeDialog, {
      visible: showResult.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((showResult).value = $event)),
      modal: "",
      header: "Result",
      style: { width: '65vw' },
      breakpoints: { '960px': '75vw', '641px': '100vw' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PolicyConfigurationSettingsTable, {
          "policy-config": currentMdmPolicy.value.policy,
          "settings-config": _unref(tableConfig),
          "edit-mode": false
        }, null, 8, ["policy-config", "settings-config"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})